import { createAction } from "../utils";
import { updateLoading } from "./loading";

const ADD_CARDS = "plt-web/cards/ADD_CARDS";
export const REMOVE_CARDS = "plt-web/cards/REMOVE_CARDS";

const initialState = [];

export default function reducer(state, { type, ...action }) {
	if (!state) {
		state = initialState;
	}
	switch (type) {
		case ADD_CARDS: {
			return action.payload;
		}
		case REMOVE_CARDS: {
			return initialState;
		}
		default:
			return state;
	}
}

export const addCards = (cards) => (dispatch) => {
	dispatch(createAction(ADD_CARDS, cards));
};

export const loadCards = (internalApi, bookingReference) => (dispatch) => {
	dispatch(updateLoading(true));
	return listCustomerCards(internalApi, { bookingReference })
		.then((res) => {
			dispatch(updateLoading(false));
			return dispatch(createAction(ADD_CARDS, res.data));
		})
		.catch((err) => {
			dispatch(updateLoading(false));
		});
};

export const listCustomerCards = (internalApi, params = {}) =>
	internalApi.get("v2/customer/me/cards", params);
